import * as ReduxUtils from "../../lib/util/ReduxUtils";

import * as GlobalActions from "./Global.action";
import AsyncState, { createAsyncStateReducer } from "react-async-stateful";
import { User } from "../../lib/types/UserTypes";

export const MOBILE_BREAKPOINT = 1024;

export interface GlobalReducerState {
	loadingOverlay: {
		visible: boolean;
		message: string | null;
	};
	mobile: boolean;
	mobileNavVisible: boolean;
	updateDriver: AsyncState<User>;
}

const initialState: GlobalReducerState = {
	loadingOverlay: {
		visible: false,
		message: null,
	},
	mobile: window.innerWidth <= MOBILE_BREAKPOINT,
	mobileNavVisible: false,
	updateDriver: AsyncState.create(),
};

export default ReduxUtils.composeReducer(initialState, [
	createAsyncStateReducer<GlobalReducerState>({
		updateDriver: GlobalActions.updateDriver.type,
	}),

	ReduxUtils.createReducerMap({
		[GlobalActions.setMobile.type]: (state, action) => ({
			...state,
			mobile: action.payload,
		}),

		[GlobalActions.setMobileNavVisible.type]: (state, action) => ({
			...state,
			mobileNavVisible: action.payload,
		}),

		[GlobalActions.updateLoadingOverlay.type]: (state, action) => ({
			...state,
			loadingOverlay: { ...state.loadingOverlay, ...action.payload },
		}),
	}),
]);
